<script>
export default {
    data() {
        return {
            show: false,
            animate: false
        }
    },
    emits: [
        'close'
    ],
    props: {
        open: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        modalMode: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        close() {
            this.$emit('close')
        }
    },
    watch: {
        open: {
            handler() {
                if(this.open) {
                    this.show = true;
                    setTimeout(() => {
                        this.animate = true
                    }, 100)
                } else {
                    this.animate = false;
                    setTimeout(() => {
                        this.show = false
                    }, 100)
                }
            }
        }
    }
}
</script>

<template>
    <teleport to="#app">
        <!-- Drawer -->
        <div v-if="show"
        class="fixed top-1 bottom-1 w-80 bg-white border border-oakwood-gray-200 rounded-lg p-6 flex flex-col transition-all duration-100 ease-in-out"
        :class="[animate ? (modalMode ? 'right-1 shadow-lg z-[60]' : 'right-1 shadow-lg z-50') : '-right-96 z-0']"
        >
            <div class="flex flex-col h-full overflow-y-auto">
                <div class="flex gap-4 justify-between items-center mb-4 flex-0 sticky top-0 bg-white">
                    <h1 class="text-3xl text-bhav-cool-gray-900 font-medium leading-9 font-headline antialiased ">{{ title }}</h1>
                    <p class="bg-bhav-cool-gray-50 text-bhav-blue-500 rounded-full text-center h-8 aspect-square flex items-center justify-center cursor-pointer" @click="close">
                        <span class="far fa-times"></span>
                    </p>
                </div>
                <slot :close="close"></slot>
            </div>
        </div>
        <!-- Click Outside Overlay -->
        <div v-if="show" @click="close" class="fixed inset-0" :class="modalMode ? 'z-[55]' : 'z-40'"></div>
    </teleport>
</template>